module.exports = __webpack_public_path__ + "img/低碳类.60708d44.jpg";